//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import CommonTabs from '@/components/views/common_tabs'

import CommonSelect from '@/components/form/common_select'
import { handleItem } from './utils'
const downpayment_percentage = [0,3, 0.6]
export default {
    props: {
        show_tip: {
            type: Boolean
        }
    },
    components: {
        CommonTabs,
        CommonSelect,

    },
    data () {
        return {
            block_names: [],
            house_decorate_prices: [],
            selected_decorate_price: 0,
            show_decorate_select: false,
            house_prices: [],
            selected_tab: 0
        }
    },
    computed: {
        houses_height () {
            return (this.house_prices.length * 186 - 1) + 'px'
        },
        decorator_select_tx () {
            return '装修价格'
        },
        tab_view_id () {
            const number = this.selected_tab > 0 ? this.selected_tab - 1 : 0
            return  `tab_item_${number}`
        }
    },
    mounted () {
        const { type } = this.$route.query
        this.type = type
        this.getData()
    },
    methods: {
        toggleDecorateSelect () {
            this.show_decorate_select = !this.show_decorate_select
        },
        changeDecorate (index) {
            if (!this.house_prices || !this.house_prices.length) {
                return
            }
            this.selected_decorate_price = index
            const decorate_price = this.house_decorate_prices[index].value
            this.house_prices = this.house_prices.map((item) => {
                item.houses = item.houses ? item.houses.map((house) => handleItem(house, {
                    decorate_price,
                    downpayment_percentage
                })) : []
                return item
            })
        },
        getData () {
            const { house_id } = this.$route.query
            let params
            if (this.block_names.length) {
                const { block, unit } = this.block_names[this.selected_tab]
                params = {
                    block,
                    unit
                }
            }
            let method = 'getBlockPrices'
            if (this.type === 'surplus_apartments') {
                method = 'getSurplusBlockPrices'
            }
            this.$wx.showLoading()
            Service[method](house_id, params).then((data) => {
                this.block_names = data.block_names ? data.block_names.map(({ block, unit }, i) => {
                    const name = `${block}${unit}`
                    return {
                        name,
                        block,
                        unit,
                        key: i
                    }
                }) : []
                this.house_decorate_prices = data.house_decorate_prices ? data.house_decorate_prices.map(({ decorate_price, decorate_type, layout_type }) => {
                    return {
                        value: decorate_price,
                        text: `${decorate_price}元/㎡（${decorate_type}，适用${layout_type}）`
                    }
                }) : []
                let decorate_price = 0
                if (this.house_decorate_prices.length) {
                    decorate_price = this.house_decorate_prices[this.selected_decorate_price].value
                }
                const house_prices = data.house_prices || data.surplus_apartments
                this.house_prices = Object.keys(house_prices).sort((a, b) => b - a).map((floor) => {
                    const houses = house_prices[floor].map((house) => handleItem(house, {
                        decorate_price,
                        downpayment_percentage
                    }))
                    return {
                        floor,
                        houses
                    }
                })
                this.$wx.hideLoading()
            })
        },
        changeTab (index) {
            this.selected_tab = index
            this.getData()
        },
        clickHouse (id) {
            this.$emit('goDetail', id)
        }
    }
}
